import { create } from "zustand";
import { useAddTourDeviationSlice } from "../slices/TourDeviationReportSlices/addTourDeviationSlice";
import { useAddUserTourDeviationSlice } from "../slices/TourDeviationReportSlices/addUserTourDeviationSlice";

interface TourDeviationReportInterface
    extends ReturnType<typeof useAddTourDeviationSlice>,
    ReturnType<typeof useAddUserTourDeviationSlice> {}

export const TourDeviationReportStore = create<TourDeviationReportInterface>(
  (...a) => ({
        ...useAddTourDeviationSlice(...a), 
        ...useAddUserTourDeviationSlice(...a),
  })
);